import 'lazysizes';
// import GlobalNav from './components/global-nav';
import Carousel from './components/Carousel';
// import CheckoutCoupon from './components/CheckoutCoupon';
// import { MiniCartToggle } from './components/MiniCart';
import './components/CodeHighlight';
import './components/StickyNav';
// import './components/Woocommerce';
import AOS from 'aos';
// import { GlobalNav } from './components/global-nav';

// import NewsFeed from './components/NewsFeed.vue';


// class Main {
//   constructor(){
//     this.init();
//   }

//   init(){
//     new GlobalNav();
//     new ShortcodeAccordion();
//     // new Vue({
//     //   el: '#news-feed'
//     // });
//   }
// }

// (function($){

//   let main = new Main;

// })(jQuery);

window.addEventListener('load', () => {
    // MiniCartToggle();
    // new CheckoutCoupon();
    Carousel();
    AOS.init();

    // GlobalNav();
});
